import React from "react";
import "../css/Projects.css";

import { projectsData, generateGradientVars } from "./Projects";

// Components
import Badge from "./Badge";
import Card from "./Card";
import MacWindow from "./MacWindow";
import { MdOutlineLaunch } from "react-icons/md";
import { SiGithub } from "react-icons/si";

const cssProjects = projectsData.filter((project) =>
    project.title === "Vantage" || project.stack.some((tech) => tech.name === "CSS")
);

function CSSProjects() {
    return (
        <div className="projects-wrapper">
            <div className="purple-line-container-project-top">
                <div className="purple-line-project-top"></div>
            </div>
            <h1 className="hero-title">CSS Projects</h1>
                    <p className="hero-subtitle">
                        built by <a href="https://themaverick.tech" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "underline" }}>Kishore N E</a>
                    </p>
            <div className="projects-container">
                <Badge><span className="badge-star">✦</span>CSS Projects</Badge>

                {cssProjects.map((project, index) => (
                    <Card key={index}>
                        <div className="projects-outer">
                            <div className="projects" style={generateGradientVars(project.accentColor)}>
                                <div className="purple-line-container-project">
                                    <div className="purple-line-project"></div>
                                </div>
                                <div className="project-heading">
                                    <div className="project-title">
                                        <h1 className="project-title-main">
                                            {project.title} <span className="bar">|</span>
                                            <span className="project-title-secondary"> {project.subtitle}</span>
                                        </h1>
                                    </div>
                                    <div className="project-description">
                                        <p>{project.description}</p>
                                    </div>
                                    <div className="project-stack">
                                        {project.stack.map((tech, i) => (
                                            <div key={i} className="stack-item">
                                                {tech.icon}
                                                <p>{tech.name}</p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="project-image">
                                    <MacWindow url={project.url}>
                                        <a href={project.liveLink} target="_blank" rel="noopener noreferrer">
                                            {project.video ? (
                                                <video src={project.video} autoPlay loop muted playsInline className="project-video">
                                                    Your browser does not support the video tag.
                                                </video>
                                            ) : (
                                                <img src={project.image} alt={`${project.title} Demo`} />
                                            )}
                                        </a>
                                    </MacWindow>
                                </div>
                                <div className="project-footer">
                                    <a href={project.liveLink} target="_blank" rel="noopener noreferrer">
                                        <button className="project-button"><MdOutlineLaunch />Live Website</button>
                                    </a>
                                    <a href={project.githubLink} target="_blank" rel="noopener noreferrer">
                                        <button className="project-button"><SiGithub />GitHub Repo</button>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </Card>
                ))}
            </div>
        </div>
    );
}

export default CSSProjects;
